import styled from 'styled-components'

export const Layout = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 77px;
  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    padding-top: ${({ theme }) => theme.spacing.km6};
  }
`

export const Container = styled.div`
  width: 478px;
  padding: ${({ theme }) => theme.spacing.km16};
  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    padding: ${({ theme }) => theme.spacing.km0} ${({ theme }) => theme.spacing.km4};
    width: 100%;
  }
`
